// 导出页面为PDF格式
import html2canvas from "html2canvas";
import JSPDF from "jspdf";

export default {
  install (Vue, options) {
    Vue.prototype.ExportSavePdf = function (htmlTitle, currentTime) {
      var element = document.getElementById("pdfCentent");

      // 不分页
      html2canvas(element, {
        logging: false
      }).then(function (canvas) {

        var contentWidth = canvas.width;
        var contentHeight = canvas.height;

        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = contentWidth / 595.28 * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //pdf页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 555.28;
        var imgHeight = 555.28/contentWidth * contentHeight;

        var pageData = canvas.toDataURL('image/jpeg', 1.0);

        var pdf = new JSPDF('', 'pt', 'a4');
        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
            pdf.addImage(pageData, 'JPEG', 20, 0, imgWidth, imgHeight );
        } else {
            while(leftHeight > 0) {
                pdf.addImage(pageData, 'JPEG', 20, position, imgWidth, imgHeight)
                leftHeight -= pageHeight;
                position -= 841.89;
                //避免添加空白页
                if(leftHeight > 0) {
                    pdf.addPage();
                }
            }
        }

        pdf.save('content.pdf');
      })

      // var element = document.getElementById("pdfCentent");
      // 分页
      // html2canvas(element, {
      //   logging: false
      // }).then(function (canvas) {
      //   var pdf = new JSPDF("p", "mm", "a4") // A4纸，纵向
      //   var ctx = canvas.getContext("2d")
      //   var a4w = 180; var a4h = 257 // A4大小，210mm x 297mm，四边各保留20mm的边距，显示区域170x257
      //   var imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度
      //   var renderedHeight = 0
 
      //   while (renderedHeight < canvas.height) {
      //     var page = document.createElement("canvas")
      //     page.width = canvas.width
      //     page.height = Math.min(imgHeight, canvas.height - renderedHeight)// 可能内容不足一页
 
      //     // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
      //     page.getContext("2d").putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)
      //     pdf.addImage(page.toDataURL("image/jpeg", 1.0), "JPEG", 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距
 
      //     renderedHeight += imgHeight
      //     if (renderedHeight < canvas.height) { pdf.addPage() }// 如果后面还有内容，添加一个空页
      //     // delete page;
      //   }
      //   pdf.save(htmlTitle + currentTime)
      // })

      // 不分页
      // html2canvas(element, {
      //   allowTaint: true,
      //   scale: 2, // 提升画面质量，但是会增加文件大小
      //   logging: false
      // }).then(function (canvas) {
      //    /**jspdf将html转为pdf一页显示不截断，整体思路：
      //    * 1. 获取DOM 
      //    * 2. 将DOM转换为canvas
      //    * 3. 获取canvas的宽度、高度（稍微大一点）
      //    * 4. 将pdf的宽高设置为canvas的宽高
      //    * 5. 将canvas转为图片
      //    * 6. 实例化jspdf，将内容图片放在pdf中（因为内容宽高和pdf宽高一样，就只需要一页，也防止内容截断问题）
      //    */

      //   // 得到canvas画布的单位是px 像素单位
      //   var contentWidth = canvas.width
      //   var contentHeight = canvas.height

      //   console.log('contentWidth', contentWidth)
      //   console.log('contentHeight', contentHeight)
      //   // 将canvas转为base64图片
      //   var pageData = canvas.toDataURL('image/jpeg', 1.0)

      //   // 设置pdf的尺寸，pdf要使用pt单位 已知 1pt/1px = 0.75   pt = (px/scale)* 0.75
      //   // 2为上面的scale 缩放了2倍
      //   var pdfX = (contentWidth + 10) / 2 * 0.75
      //   var pdfY = (contentHeight + 500) / 2 * 0.75 // 500为底部留白

      //   // 设置内容图片的尺寸，img是pt单位 
      //   var imgX = pdfX;
      //   var imgY = (contentHeight / 2 * 0.75); //内容图片这里不需要留白的距离

      //   // 初始化jspdf 第一个参数方向：默认''时为纵向，第二个参数设置pdf内容图片使用的长度单位为pt，第三个参数为PDF的大小，单位是pt
      //   var PDF = new JSPDF('', 'pt', [pdfX, pdfY])

      //   // 将内容图片添加到pdf中，因为内容宽高和pdf宽高一样，就只需要一页，位置就是 0,0
      //   PDF.addImage(pageData, 'jpeg', 10, 10, imgX, imgY)
      //   PDF.save(htmlTitle + currentTime)
      // })
    }
  }
}